/* eslint-disable @typescript-eslint/no-unused-vars */
import { View, Text as PDFText } from '@react-pdf/renderer'
import moment from 'moment-jalaali'

import { getCurrencyLabel } from '../../../../../helpers/currencies'
import { RoomStay } from '../../../../../types/bookingDetails'
import { Currency } from '../../../../../types/currency'
import convertNumberToWord from '../../config/convertNumberToWord'
import { addCommaToPrice, formatJalaaliDate } from '../../config/functions'
import styles from './styles/index.styles'

interface RoomDetailsProps {
  data: RoomStay
  index: number
  currency: Currency
}

export const RoomDetails = ({ data, index, currency }: RoomDetailsProps) => {
  const haveExtraBedPrice = data.ratesPerDay.some((item) => item.extraBedRate)

  return (
    <View style={styles.mainDiv} wrap={false}>
      <View style={styles.content}>
        <View style={styles.contentColumn1}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:نام میهمان</PDFText>
            <PDFText style={styles.subjectValue}>
              {`${data.profiles[0].firstName} ${data.profiles[0].lastName}`}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:کد ملی</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.profiles[0].identificationNo}
            </PDFText>
          </View>
        </View>
        <View style={styles.contentColumn2}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:تاریخ ورود</PDFText>
            <PDFText style={styles.subjectValue}>
              {moment(data.checkIn).format('jYYYY/jMM/jDD')}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:تاریخ خروج</PDFText>
            <PDFText style={styles.subjectValue}>
              {moment(data.checkOut).format('jYYYY/jMM/jDD')}
            </PDFText>
          </View>
        </View>
        <View style={styles.contentColumn3}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:تعداد میهمان</PDFText>
            {/* Separate Texts in a row-reverse container: the renderer cannot be trusted
                to order mixed numbers, words and parentheses inside one RTL string. */}
            <View style={styles.numberOfGuestsContainer}>
              <PDFText style={styles.subjectValue}>
                {data.numberOfAdults}
              </PDFText>
              {data.addBed > 0 && (
                <>
                  <PDFText style={styles.subjectValue}> با </PDFText>
                  <PDFText style={styles.subjectValue}>{data.addBed}</PDFText>
                  <PDFText style={styles.subjectValue}> تخت اضافی</PDFText>
                </>
              )}
            </View>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:قیمت هر شب</PDFText>
            {data.ratesPerDay.map((singleDay, i) => (
              <View
                key={i}
                style={{ flexDirection: 'row', alignItems: 'center' }}>
                <PDFText style={styles.subjectValue}>
                  {getCurrencyLabel(currency)}&nbsp;
                  {addCommaToPrice(singleDay.roomRate)}&nbsp; -&nbsp;
                  {formatJalaaliDate(singleDay.date)}
                </PDFText>
                <View
                  style={{
                    width: 5,
                    height: 5,
                    borderRadius: 5,
                    backgroundColor: 'black',
                    marginLeft: 6
                  }}
                />
              </View>
            ))}
          </View>
          {haveExtraBedPrice && (
            <View style={styles.subject}>
              <PDFText style={styles.subjectTitle}>:قیمت تخت اضافه</PDFText>
              {data.ratesPerDay.map((singleDay, i) => (
                <PDFText key={i} style={styles.subjectValue}>
                  {getCurrencyLabel(currency)}&nbsp;
                  {addCommaToPrice(singleDay.extraBedRate)}&nbsp; -&nbsp;
                  {formatJalaaliDate(singleDay.date)}
                </PDFText>
              ))}
            </View>
          )}
        </View>
        <View style={styles.contentColumn4}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>:شماره رزرو</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.displayReservationNumber}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>{`:PMS شماره رزرو `}</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.pmsNumber ? data.pmsNumber : ''}
            </PDFText>
          </View>
        </View>
      </View>
      <View style={styles.roomTitleContainer}>
        <View style={styles.roomTitle}>
          <PDFText style={styles.roomTitleLabel}>
            : اتاق {convertNumberToWord(index + 1, 'fa')}
          </PDFText>
          <PDFText style={styles.roomTitleValue}>
            {data.roomTypeName.replace(/\(|\)/g, ($1) => {
              return $1 === ')' ? '(' : ')'
            })}
          </PDFText>
        </View>
      </View>
    </View>
  )
}
